import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludedGrid } from './components/IncludedGrid';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { TransformSection } from './components/TransformSection';
import { PricingCard } from './components/PricingCard';
import { WhyCoaches } from './components/WhyCoaches';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1767171584537640');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="st2hsfuf4rho">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1767171584537640&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="swqbpg3rzfwx" />
      </noscript>
      <div className="w-full min-h-screen bg-ivory text-petrol overflow-x-hidden" data-id="element-2" data-mp="d4o09u01u88q">
        <main data-id="element-3" data-mp="d2bgrcen7ptk">
          <Hero data-id="element-4" data-mp="85ui3o9tht28" />
          <StatsBar data-id="element-5" data-mp="85bbv4tj4t41" />
          <ProblemSection data-id="element-6" data-mp="86w76wno4g2y" />
          <SolutionSection data-id="element-7" data-mp="83i2hhrj7usc" />
          <IncludedGrid data-id="element-8" data-mp="3gl4rzijy82kk" />
          <ModulesSection data-id="element-9" data-mp="3gkl6xsz04y2b" />
          <BonusSection data-id="element-10" data-mp="3glwg68b7uy0t" />
          <TransformSection data-id="element-11" data-mp="3gj1rg4l66r1l" />
          <PricingCard data-id="element-12" data-mp="3bmtgl3e09k08" />
          <WhyCoaches data-id="element-13" data-mp="3bnmgbkejr98v" />
          <Guarantee data-id="element-14" data-mp="3bo4l55f9yvse" />
          <Testimonials data-id="element-15" data-mp="3qb7inc3ll4fq" />
          <FAQ data-id="element-16" data-mp="3qbpl4qgusew3" />
          <FinalCTA data-id="element-17" data-mp="3qc950cq2ddcr" />
        </main>
        <Footer data-id="element-18" data-mp="3qdai0mqn49x4" />
      </div>
    </>;
}